import { get, noop } from "lodash";

import tvgConf from "@tvg/conf";
import { getPortByBrand } from "@tvg/utils/generalUtils";

const LABELS = {
  BET: "bet",
  RES: "res",
  PROMO: "promo"
};

const POLL_INTERVAL = 60000;

const labelCreator = (track) => {
  let labels = [];

  if (track.hasAboveTheLinePromo) {
    labels.push({
      text: LABELS.PROMO,
      type: "secondary"
    });
  }

  if (track.isFinished) {
    labels = [];
    labels.push({
      text: LABELS.RES,
      type: "secondary"
    });
  }

  return labels;
};

// TODO: Import CombinedHeaderTracksActions
const tracksAZDataFeeder = (tracks = [], hasError = false) => {
  const finalStruct = {
    tracks: [],
    isLoading: true,
    hasError,
    refetch: noop
  };

  finalStruct.tracks = tracks.map((track) => ({
    name: track.name,
    shortName: track.shortName,
    code: track.code,
    isFavorite: track.isFavorite,
    favorite: track.favorite,
    hasPromo: track.hasAboveTheLinePromo || track.hasPromo,
    isFinished: track.isFinished,
    isGreyhound: track.isGreyhound,
    labels: labelCreator(track),
    isOpen: false,
    isPromoTagShown: get(track, "isPromoTagShown", false)
  }));

  return finalStruct;
};

const INCLUDE_GREYHOUNDS = true;

const buildQueryVariables = (
  wagerProfile = "PORT-Generic",
  raceTypeFilters = [],
  regionFilters = [],
  isFinished,
  amountOfFavoriteTracks = 0
) => {
  const queryVariables = {
    amountOfFavoriteTracks,
    wagerProfile,
    sortByName: { byName: "ASC" },
    trackFilters: { allTrackClasses: INCLUDE_GREYHOUNDS, isFinished },
    product: tvgConf().product,
    brand: tvgConf().brand
  };

  if (raceTypeFilters.length) {
    queryVariables.trackFilters.raceTypes = raceTypeFilters;
  }

  if (regionFilters.length) {
    if (regionFilters.indexOf("USA") >= 0 && regionFilters.indexOf("INT") < 0) {
      queryVariables.trackFilters.includeCountries = ["USA"];
    }

    if (regionFilters.indexOf("USA") < 0 && regionFilters.indexOf("INT") >= 0) {
      queryVariables.trackFilters.excludeCountries = ["USA"];
    }
  }

  return queryVariables;
};

const QUERY_VARIABLES = {
  wagerProfile: "PORT-Generic",
  accountId: ""
};

const loggedInOptions = (props, isFinished) => {
  const builtVariables = buildQueryVariables(
    props.wagerProfile,
    undefined,
    undefined,
    isFinished,
    props.amountOfFavoriteTracks
  );
  return {
    ...QUERY_VARIABLES,
    ...builtVariables,
    accountId: +get(props, "accountId", "-1"),
    wagerProfile: get(props, "wagerProfile", getPortByBrand())
  };
};

export default {
  options: (props) => {
    const onlyFetchResultedTracks = undefined;
    const loggedInVariables = props.isLogged
      ? loggedInOptions(props, onlyFetchResultedTracks)
      : {};
    const queryVariables = buildQueryVariables(
      props.wagerProfile,
      props.raceTypeFilters,
      props.regionFilters,
      onlyFetchResultedTracks,
      props.amountOfFavoriteTracks
    );

    return {
      client:
        props.isAccountCompliant && !!get(props, "accountId", "")
          ? props.rdaClient
          : null,
      pollInterval: POLL_INTERVAL,
      fetchPolicy: "cache-and-network",
      ssr: false,
      variables: {
        ...loggedInVariables,
        ...queryVariables
      }
    };
  },
  props: (result) => {
    let hasError = false;

    if (get(result, "data.error", undefined) !== undefined) {
      hasError = true;
    }
    return Object.assign(
      tracksAZDataFeeder(get(result, "data.tracks", []), hasError),
      {
        isLoading: result.data.loading,
        refetch: result.data.refetch
      }
    );
  }
};
